export default "__VITE_ASSET__BjvIVCY7__"